import Vue from 'vue'
import Router from 'vue-router'
import index from '@/view/index/index'
import parkDynamics from '@/view/parkDynamics/index'
import parkDynamicsDetail from '@/view/parkDynamics/detail'
import futureCityDescription from '@/view/parkDescription/futureCityDescription'
import importantPark from '@/view/parkDescription/importantPark'
import freeTradeAgreement from '@/view/parkDescription/freeTradeAgreement'
import twoRegionActivity from '@/view/twoRegionActivity/index'
import twoRegionActivityDetail from '@/view/twoRegionActivity/detail'
import twoRegionPolicySearch from '@/view/twoRegionPolicy/twoRegionPolicySearch'
import regionPolicyDetail from '@/view/twoRegionPolicy/regionPolicyDetail'
import policyInterpretation from '@/view/twoRegionPolicy/policyInterpretation'
import policyInterpretationDetail from '@/view/twoRegionPolicy/policyInterpretationDetail'
import twoRegionPolicyAnnouncement from '@/view/twoRegionPolicy/twoRegionPolicyAnnouncement'
import twoRegionPolicyAnnouncementDetail from '@/view/twoRegionPolicy/twoRegionPolicyAnnouncementDetail'
import governmentAffairsService from '@/view/governmentAffairsService/index'
import governmentAffairsServiceDetail from '@/view/governmentAffairsService/governmentAffairsServiceDetail'
import innovationCase from '@/view/innovationCase/index'
import innovationCaseDetail from '@/view/innovationCase/innovationCaseDetail'
import unionEnterprises from '@/view/unionEnterprises/index'
import unionEnterprisesDetail from '@/view/unionEnterprises/unionEnterprisesDetail'
import developmentEmpowerment from '@/view/developmentEmpowerment/index'
import activityRegistration from '@/view/activityRegistration/index'
import activityRegistrationDetail from '@/view/activityRegistration/activityRegistrationDetail'
import appeal from '@/view/appeal/index'
import appealDetail from '@/view/appeal/appealDetail'
import appealForm from '@/view/appeal/appealForm'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/index/index',
      name: 'index',
      component: index
    },
    {
      path: '/parkDynamics/index',
      name: 'parkDynamics',
      component: parkDynamics
    },
    {
      path: '/parkDynamics/detail',
      name: 'parkDynamicsDetail',
      component: parkDynamicsDetail
    },
    {
      path: '/parkDescription/futureCityDescription',
      name: 'futureCityDescription',
      component: futureCityDescription
    },
    {
      path: '/parkDescription/importantPark',
      name: 'importantPark',
      component: importantPark
    },
    {
      path: '/parkDescription/freeTradeAgreement',
      name: 'freeTradeAgreement',
      component: freeTradeAgreement
    },
    {
      path: '/twoRegionActivity/index',
      name: 'twoRegionActivity',
      component: twoRegionActivity
    },
    {
      path: '/twoRegionActivity/detail',
      name: 'twoRegionActivityDetail',
      component: twoRegionActivityDetail
    },
    {
      path: '/twoRegionPolicy/twoRegionPolicySearch',
      name: 'twoRegionPolicySearch',
      component: twoRegionPolicySearch
    },
    {
      path: '/twoRegionPolicy/regionPolicyDetail',
      name: 'regionPolicyDetail',
      component: regionPolicyDetail
    },
    {
      path: '/twoRegionPolicy/policyInterpretation',
      name: 'policyInterpretation',
      component: policyInterpretation
    },
    {
      path: '/twoRegionPolicy/policyInterpretationDetail',
      name: 'policyInterpretationDetail',
      component: policyInterpretationDetail
    },
    {
      path: '/twoRegionPolicy/twoRegionPolicyAnnouncement',
      name: 'twoRegionPolicyAnnouncement',
      component: twoRegionPolicyAnnouncement
    },
    {
      path: '/twoRegionPolicy/twoRegionPolicyAnnouncementDetail',
      name: 'twoRegionPolicyAnnouncementDetail',
      component: twoRegionPolicyAnnouncementDetail
    },
    {
      path: '/governmentAffairsService/index',
      name: 'governmentAffairsService',
      component: governmentAffairsService
    },
    {
      path: '/governmentAffairsService/governmentAffairsServiceDetail',
      name: 'governmentAffairsServiceDetail',
      component: governmentAffairsServiceDetail
    },
    {
      path: '/innovationCase/index',
      name: 'innovationCase',
      component: innovationCase
    },
    {
      path: '/innovationCase/innovationCaseDetail',
      name: 'innovationCaseDetail',
      component: innovationCaseDetail
    },
    {
      path: '/unionEnterprises/index',
      name: 'unionEnterprises',
      component: unionEnterprises
    },
    {
      path: '/unionEnterprises/unionEnterprisesDetail',
      name: 'unionEnterprisesDetail',
      component: unionEnterprisesDetail
    },
    {
      path: '/developmentEmpowerment/index',
      name: 'developmentEmpowerment',
      component: developmentEmpowerment
    },
    {
      path: '/activityRegistration/index',
      name: 'activityRegistration',
      component: activityRegistration
    },
    {
      path: '/activityRegistration/activityRegistrationDetail',
      name: 'activityRegistrationDetail',
      component: activityRegistrationDetail
    },
    {
      path: '/appeal/index',
      name: 'appeal',
      component: appeal
    },
    {
      path: '/appeal/appealDetail',
      name: 'appealDetail',
      component: appealDetail
    },
    {
      path: '/appeal/appealForm',
      name: 'appealForm',
      component: appealForm
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js